<mat-form-field>
  <mat-label>{{ 'common.scale' | translate }}</mat-label>
  <mat-select [value]="value" (selectionChange)="change.emit($event.value)">
    <mat-option *ngFor="let scale of scales" [value]="scale.value" [innerHtml]="scale.label">
    </mat-option>
  </mat-select>
</mat-form-field>
